import React from "react";

const LazyCompleteProfile = React.lazy(() => import("./complete-profile"));

const CompleteProfileContainer: React.FC = () => {
  return (
    <React.Suspense fallback={<div>Loading...</div>}>
      <LazyCompleteProfile />
    </React.Suspense>
  );
};

export default CompleteProfileContainer;